/**
 * Created by Shiv Roy on 29/9/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import user1 from '../../../img/noimage.png';
import { ProfileModal } from './../component/displayProfile';
// import { NavLink } from 'react-router-dom';
import { base64Encode, showFormatedDate } from '../../../actions/utilAction';

class UserInfoHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openImage: false,
    };
  }
  handleOpen = () => {
    this.setState({ openImage: true });
  };

  handleClose = () => {
    this.setState({ openImage: false });
  };

  render() {
    const { photoPath, photoThumbnailPath, isBlock, isActive, genderName, firstName, middleName, lastName, dob, address, phoneNumber } = this.props.activeStaffInfo || {};
    let name = firstName + ' ' +  lastName;
    let activeClassName = `user_pic ${isActive ? 'activec' : 'inactive'} ${isBlock ? 'lock' : ''}`,
      activeIcon = isBlock ? (<i className="fa fa-lock" aria-hidden="true"></i>) : (<i className="fa fa-circle" aria-hidden="true"></i>);
    //let encodeStaffId = base64Encode(this.props.staffId);
    return (
      <div className="client_profile">
        <ProfileModal openImage={(this.state.openImage && photoPath) ? true : false} closeDialog={this.handleClose} profileFullPicture={photoPath}/>
        <div className="clientbox">
          <div className={activeClassName}>
            {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name.toUpperCase()}</span>) : ''}
            {activeIcon}
          </div>

          {/* {this.props.activeUser && this.props.activeUser.isActive === false && this.props.activeUser.isBlock === false ?
            <div className="user_pic inactive">
              <img src={this.props.activeUser && this.props.activeUser.photoThumbnailPath ? this.props.activeUser.photoThumbnailPath : user1} alt="" onClick={this.handleOpen} />
              <i className="fa fa-circle" aria-hidden="true"></i>
            </div>
            : null} */}

          <div className="userlinks">
            <p>
              {/* <NavLink to={`/user-profile/${encodeStaffId}`} exact >{`${firstName || ''} ${middleName || ''} ${lastName || ''}`}</NavLink> */}
              {`${firstName || ''} ${middleName || ''} ${lastName || ''}`}
            </p>
          </div>
          <div className="client_detail">
            <p><b>Gender :</b> <span>{genderName || '-'}</span></p>
            <p><b>D.O.B :</b> <span>{dob ? showFormatedDate(dob) : ''}</span></p>
            <p><b>Address: </b> <span>{address || '-'}</span></p>
            <p><b>Phone Number : </b> <span>{phoneNumber || '-'}</span></p>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  let activeStaffInfo = null;
  if (state.user.staffDetails && state.user.staffDetails.data) {
    activeStaffInfo = state.user.staffDetails.data;
  } else if (state.user.saved_StaffDetails && state.user.saved_StaffDetails.data) {
    activeStaffInfo = state.user.saved_StaffDetails.data;
  }
  return {
    activeStaffInfo: activeStaffInfo,
  };
};

export default connect(mapStateToProps, null)(UserInfoHeader);



// WEBPACK FOOTER //
// ./src/modules/users/User/UserInfoHeader.js